require('@rails/activestorage').start()
require('channels')

const Uppy = require('@uppy/core')
const Dashboard = require('@uppy/dashboard')
const ActiveStorageUpload = require('@excid3/uppy-activestorage-upload')
const ThumbnailGenerator = require('@uppy/thumbnail-generator')

require('@uppy/core/dist/style.css')
require('@uppy/dashboard/dist/style.css')

let okToSetPreview = true
let uppies = []

const loadUppy = () => {
  document
    .querySelectorAll('[data-uppy]')
    .forEach((element) => setupUppy(element))
}

document.addEventListener('turbo:load', loadUppy)
document.addEventListener('modal:load', loadUppy)
document.addEventListener('uppy:reinit', () => {
  uppies.forEach((u) => u.close)
  loadUppy()
})

function setupUppy(element) {
  let trigger = element.querySelector('[data-behavior="uppy-trigger"]')
  if (trigger.getAttribute("data-uppy-configured")) {
    // already configured, so let's return to prevent duplicate binds
    return
  }
  trigger.setAttribute("data-uppy-configured", "true")

  let form = element.closest('form')
  let direct_upload_url = document
    .querySelector("meta[name='direct-upload-url']")
    .getAttribute('content')
  let field_name = element.dataset.uppy

  trigger.addEventListener('click', (event) => event.preventDefault())

  let uppy = Uppy({
    autoProceed: true,
    allowMultipleUploads: false,
    restrictions: {
      maxFileSize: 2097152,
      allowedFileTypes: ['.jpg', '.jpeg', '.png']
    }
  })

  uppy.use(ActiveStorageUpload, {
    directUploadUrl: direct_upload_url,
  })

  // A native <dialog> shown via showModal() puts everything outside its own
  // DOM subtree in the "background" — inert and un-clickable — regardless
  // of paint order. Uppy's Dashboard modal mounts as a sibling of <body> by
  // default, so when a [data-uppy] trigger lives inside one of our
  // portal-turbo-modal dialogs, the dashboard would render behind it (or, if
  // forced on top via z-index/popover tricks, render on top but inert).
  // Mounting it inside the ancestor <dialog> via Uppy's own `target` option
  // makes Preact manage the placement correctly from the start, so it's a
  // real descendant of the dialog: not inert, and naturally stacked above
  // the dialog's own content.
  const dialog = element.closest('dialog')

  uppy.use(Dashboard, {
    trigger: trigger,
    target: dialog || 'body',
    closeAfterFinish: true,
    proudlyDisplayPoweredByUppy: false,
    locale: {
      strings: {
        dropPaste: 'Drop files here or %{browse}',
      },
    },
  })

  uppy.use(ThumbnailGenerator, {
    thumbnailWidth: 336,
    waitForThumbnailsBeforeUpload: false,
    thumbnailType: 'image/png',
  })

  uppy.on('thumbnail:generated', (file, preview) => {
    if (okToSetPreview) setPreview(element, file)
  })

  uppy.on('complete', (result) => {
    element
      .querySelectorAll('[data-pending-upload]')
      .forEach((element) => element.parentNode.removeChild(element))

    result.successful.forEach((file) => {
      appendUploadedFile(element, file, field_name)
    })

    uppy.reset()
    uppies.push(uppy)
  })
}

function appendUploadedFile(element, file, field_name) {
  const hiddenField = document.createElement('input')

  hiddenField.setAttribute('type', 'hidden')
  hiddenField.setAttribute('name', field_name)
  hiddenField.setAttribute('data-pending-upload', true)
  hiddenField.setAttribute('value', file.response.signed_id)

  element.appendChild(hiddenField)
}

function setPreview(element, file) {
  let preview = element.querySelector('[data-behavior="uppy-preview"]')
  if (preview) {
    let src = file.preview
      ? file.preview
      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSpj0DBTVsaja01_xWh37bcutvpd7rh7zEd528HD0d_l6A73osY'
    preview.src = src
  }

  let previewHelper = element.querySelector('[data-behavior="uppy-preview-helper"]')
  if (previewHelper) {
    previewHelper.classList.add("hidden")
  }

  okToSetPreview = false
  setTimeout(() => okToSetPreview = true, 500)
}
